class NewsLetterPopup extends HTMLElement {
  constructor() {
    super();

    if (window.location.pathname === '/challenge') {
      return;
    }

    this.cookieName = 'luxury_newsletter_popup';
    this.popup = this;

    this.classes = {
      bodyClass: 'modal-open',
      activeClass: 'active',
      closingClass: 'closing',
    };

    // fallback expiry (days)
    this.expiry = parseInt(this.dataset.expiry, 10) || 30;

    if (this.querySelector('.form-message')) {
      this.open();
    }

    this.querySelectorAll('[data-popup-close]').forEach((button) => {
      button.addEventListener('click', this.onButtonClick.bind(this));
    });

    if (!this.getCookie(this.cookieName)) {
      this.init();
    }
  }

  init() {
    if (!this.popup) return;

    setTimeout(() => {
      this.open();
    }, 2000);
  }

  onButtonClick(event) {
    event.preventDefault();

    if (this.popup.classList.contains(this.classes.activeClass)) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    if (this.getCookie(this.cookieName)) return;

    if (this.dataset.newsletterpopup === 'true') {
      document.body.classList.add(this.classes.bodyClass);
      this.popup.classList.add(this.classes.activeClass);

      this.setCookie(this.cookieName, this.expiry);
    }
  }

  close() {
    this.popup.classList.add(this.classes.closingClass);

    setTimeout(() => {
      this.popup.classList.remove(this.classes.activeClass);
      this.popup.classList.remove(this.classes.closingClass);
      document.body.classList.remove(this.classes.bodyClass);
    }, 500);

    this.setCookie(this.cookieName, this.expiry);
  }

  getCookie(name) {
    const cookies = document.cookie.split('; ');
    const cookie = cookies.find((row) => row.startsWith(name + '='));
    return cookie ? cookie.split('=')[1] : null;
  }

  setCookie(name, expiryDays) {
    const maxAge = expiryDays * 24 * 60 * 60;

    document.cookie =
      name +
      '=true; path=/; max-age=' +
      maxAge +
      '; SameSite=Lax; Secure';
  }

  removeCookie(name) {
    document.cookie = name + '=; path=/; max-age=0';
  }
}

customElements.define('newsletter-popup', NewsLetterPopup);